import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { BorderRadius, Colors, FontSizeInPx, FontWeight, Fonts, Spacing } from "@snapchat/snap-design-system";

export const pageContent = css`
    margin: 21px 48px;
    padding: ${Spacing.XL}px ${Spacing["3XL"]}px ${Spacing["2XL"]}px ${Spacing["3XL"]}px;

    text-align: center;

    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
`;

export const TextHeader = styled.h1`
    ${Fonts.Heading.H300};
    width: 100%;
    margin: 0;
    line-height: 30px;
    color: ${Colors.Black.V150};
`;

export const TextContent = styled.p`
    width: 100%;
    margin: 0;
    padding-top: ${Spacing.XS}px;

    font-size: 16px;
    font-weight: ${FontWeight.MEDIUM}px;
    line-height: 20px;
    color: ${Colors.Black.V150};
`;

export const TextSubContent = styled.p`
    width: 100%;
    margin: 0;
    padding-top: ${Spacing["2XS"]}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.MEDIUM}px;
    line-height: 20px;
    color: ${Colors.Gray.V300};
`;

export const iconStyle = {
    height: 64,
    width: 64,
    marginTop: Spacing.SM,
    marginBottom: Spacing.SM,
    alignSelf: "center",
};
